// shared/pricing.ts — single source of truth for PadPulse pricing.
// Version 2026-10-v3. Created identically by the backend and frontend build sessions.
// Do not edit without Travis. Amounts are in US cents.
import { SYRE_OCTOBER_EVENT } from "./syre-event";

export const PRICING = {
  version: '2026-10-v3',
  currency: 'usd',
  trial: { days: 14, requiresCard: false, pausedDataRetentionDays: 30 },
  // Graduated by the property's position in the account (1-based).
  hostTiersMonthly: [
    { fromProperty: 1, toProperty: 10, unitAmount: 4900 },
    { fromProperty: 11, toProperty: 50, unitAmount: 3900 },
    { fromProperty: 51, toProperty: null, unitAmount: 2900 },
  ],
  annual: { monthsCharged: 10, monthsCovered: 12, enabledFrom: '2026-11-01T00:00:00-04:00' },
  ownerPortal: { monthlyPerOwner: 1000, annualPerOwner: 10000 },
  research: { freeSearchesPerMonth: 5 },
  refunds: { monthlyDays: 0, annualDays: 30, lifetimeDays: 30 },
  lifetime: {
    offerId: 'syre-lifetime',
    priceOneTime: 300000,          // per unit
    propertyAllowance: 5,          // per unit
    maxUnits: 4,                   // stackable: 5, 10, 15 or 20 properties
    maxTotalAllowance: 20,
    defaultClosesAt: SYRE_OCTOBER_EVENT.closesAt, // fallback only; live windows come from the server (B23)
  },
  founderAllowances: { founderA: 20, founderB: 10 },
} as const;

/** Monthly Host price in cents for `properties` properties.
 *  `freeAllowance` = properties covered by a lifetime plan (0 if none). */
export function hostMonthlyCents(properties: number, freeAllowance = 0): number {
  let total = 0;
  for (let i = 1; i <= properties; i++) {
    if (i <= freeAllowance) continue;
    const tier = PRICING.hostTiersMonthly.find(
      (t) => i >= t.fromProperty && (t.toProperty === null || i <= t.toProperty),
    )!;
    total += tier.unitAmount;
  }
  return total;
}

export function ownerPortalMonthlyCents(owners: number): number {
  return Math.max(0, owners) * PRICING.ownerPortal.monthlyPerOwner;
}

export function isAnnualEnabled(now: Date = new Date()): boolean {
  return now >= new Date(PRICING.annual.enabledFrom);
}

export function isLifetimeOpen(now: Date = new Date()): boolean {
  return now <= new Date(PRICING.lifetime.defaultClosesAt);
}
